import axios from 'axios';
import { WT_API_URL, OAUTH_API_URL, AUTH_URL } from 'config/api.routes';
import {
  clearAuthSessionStorage,
  getAuthAccessToken,
  setStoredRefreshToken,
} from 'core/storage/authSessionStorage';
import getAppRefreshToken from 'service/refresh-token';
import { HttpStatusCode } from 'constants/globals';

import { getInvestmentOfficeId } from 'utils/access';

import service from './auth';

const wt_api_instance = () => {
  const instance = axios.create({
    baseURL: WT_API_URL,
  });

  instance.interceptors.request.use(
    (config) => {
      const token = getAuthAccessToken();
      if (token) config.headers.Authorization = `Bearer ${token}`;
      // eslint-disable-next-line
      config.headers['investment_office_id'] = getInvestmentOfficeId();
      return config;
    },
    (error) => {
      Promise.reject(error);
    },
  );

  instance.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {
      const originalRequest = error.config;
      const refreshToken = service.getRefreshToken();
      /* eslint no-underscore-dangle: 0 */
      const { status, data } = error.response;
      if (
        (status === HttpStatusCode.InternalServerError &&
          data.error.internal_error.includes('validar el token')) ||
        status === HttpStatusCode.Unauthorized
      )
        service.doLogin();
      if (
        status === HttpStatusCode.Unauthorized &&
        !originalRequest._retry &&
        refreshToken
      ) {
        /* eslint no-underscore-dangle: 0 */
        originalRequest._retry = true;
        const response = await getAppRefreshToken();
        const { access_token, refresh_token } = response.data;
        axios.defaults.headers.common.Authorization = `Bearer ${access_token}`;
        setStoredRefreshToken(refresh_token);
        return instance(originalRequest);
      }
      return Promise.reject(error);
    },
  );

  return instance;
};

const auth_refresh_token_instance = () => {
  const instance = axios.create({
    baseURL: AUTH_URL,
  });

  instance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (
        error?.response?.status === HttpStatusCode.NotFound ||
        error?.response?.status === HttpStatusCode.Unauthorized
      ) {
        clearAuthSessionStorage();
        service.doLogout();
      }
      return Promise.reject(error);
    },
  );

  return instance;
};

const oauth_api_instance = axios.create({
  baseURL: OAUTH_API_URL,
});

const axiosData = {
  wt_api: wt_api_instance(),
  auth_refresh_token: auth_refresh_token_instance(),
  oauth_api: oauth_api_instance,
};

export default axiosData;
